<!-- Modals -->
<app-deprecated-confirmation-dialog
    #confirmDeleteCustomReportDialog
    [label]="'Delete'"
    [description]="'Are you sure you want to delete this custom report?'"
    [negative]="true"
></app-deprecated-confirmation-dialog>

<div class="ui basic segment report-page" [class.loading]="isLoading">
    <app-header [title]="reportTitle" [back]="true" class="report-header" backRoute="/reporting/custom-reports">
        <div class="buttons">
            <ui-button type="primary" [matMenu]="exportMenu" class="export-button">
                Export <mat-icon svgIcon="chevronDown"></mat-icon>
            </ui-button>
            <mat-menu #exportMenu="matMenu">
                <button mat-menu-item (click)="onExport('csv')">Export as .csv</button>
                <button mat-menu-item (click)="onExport('xlxs')">Export as .xlxs</button>
            </mat-menu>

            <!-- Meatball menu -->
            <button class="material-meatball-menu-button meatball-icon-border" [matMenuTriggerFor]="menu">
                <img appIcon="MeatballSolid" />
            </button>
            <mat-menu #menu="matMenu" xPosition="before">
                <button mat-menu-item (click)="onEdit()">Edit</button>
                <button mat-menu-item (click)="onDelete()">Delete</button>
            </mat-menu>
        </div>
    </app-header>

    <div *ngIf="report && report.sheet; else emptyState" class="report-body">
        <app-report-table [report]="report" emptyText="There are no employees to report on."></app-report-table>
    </div>

    <ng-template #emptyState>
        <div class="ui segment">
            <app-empty-state label="There are no employees to report on."></app-empty-state>
        </div>
    </ng-template>
</div>
